let conf = {
    server_address: "https://api.radyabe.ir/api",
    // server_address: "http://localhost:8080/api",
};

export default conf;
